/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, {
    useCallback, useEffect, useMemo,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { shallowEqual } from 'recompose';
import FormikTree from 'src/components/formik/FormikTree';
import { Formik, Form } from 'formik';
import { withFormikDevtools } from 'formik-devtools-extension';
import { isProduction } from 'src/config/index';
import PropTypes from 'prop-types';
import FormikCreateSearchClear from 'src/components/formik/FormikCreateSearchClear';
import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { usePrevious } from 'src/utils/ReactHooksUtil';
import RoleDropDown from 'src/business-components/RoleDropDown';
import UserDropDown from 'src/business-components/UserDropDown';
import { includeStamp } from 'src/utils/StampUtils';
import { permissionMasterFetch } from '../permissions-container/actions/PermissionsMasterActions';
import { permissionsToTreeStructure } from '../../utils/CommonUtils';
import { userEditAction, userSearchAction, userUpsertAction } from './actions/UserActions';

const Render = (props) => {
    // DEV TOOL
    if (!isProduction()) {
        withFormikDevtools(props);
    }

    const {
        // errors,
        // touched,
        // enableDisableAction,
        // onClear,
        resetForm,
        isSubmitting,
        values,
        scopeTree,
    } = props;

    return (
        <div>
            <Form autoComplete="disabled">
                <div className="card mt-3">
                    <div className="card-body">
                        <h5 className="card-title">Add Permissions and Role</h5>

                        <div className="form-group col-md-3">
                            <label>Role</label>
                            <RoleDropDown
                                name="role"
                                value={values.role}
                            />
                        </div>

                        <div className="form-group col">
                            <label>Extra Permissions</label>
                            <FormikTree
                                nodes={scopeTree}
                                name="extraPermissions"
                                checked={values.extraPermissions}
                            />
                        </div>
                    </div>
                </div>

                <div className="text-center py-4 mt-3">
                    <FormikCreateSearchClear
                        isSubmitting={isSubmitting}
                        isUpdate={Boolean(values._id)}
                        // onClear={onClear}
                        resetForm={resetForm}
                        values={values}
                        canClear={false}
                        submitScope="people.user_manager.user_permissions.submit"
                    />
                </div>
            </Form>
        </div>
    );
};

Render.propTypes = {
    scopeTree: PropTypes.array.isRequired,
    values: PropTypes.shape({
        role: PropTypes.string,
        extraPermissions: PropTypes.array,
        _id: PropTypes.string,
    }),
    resetForm: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    // forceRefreshSearchContainer: PropTypes.func.isRequired,
    // onClear: PropTypes.func.isRequired,
};

// setting submit button state after submitting
let setSubmitting = () => { };

const UserPermissions = () => {
    // REDUX
    const dispatch = useDispatch();

    const {
        scopes,
        permissionMasterFetchReqStatus,
    } = useSelector((state) => state.PermissionsMasterReducer, shallowEqual);

    // USER RECORD
    const {
        currentRecord,
        upsertReqStatus,
    } = useSelector((state) => state.UserReducer, shallowEqual);

    // ENABLE SUBMIT AFTER XHR REQUEST
    usePrevious({
        currentRecord,
        upsertReqStatus,
    }, (prev) => {
        if (
            prev.currentRecord !== currentRecord
            || (upsertReqStatus && prev.upsertReqStatus !== upsertReqStatus && upsertReqStatus !== REQUEST_STATUS.PENDING)) {
            setSubmitting(false);
        }
    });

    useEffect(() => {
        // fetch all permission if not in store
        if (!scopes && !permissionMasterFetchReqStatus) {
            dispatch(permissionMasterFetch({
                where: {},
                currentPage: 0,
                autopopulate: false,
                fullTextSearch: false,
            }));
        }
    }, [
        dispatch,
        scopes,
        permissionMasterFetchReqStatus,
    ]);

    // create structure for tree
    const scopeTree = useMemo(() => permissionsToTreeStructure(scopes), [
        scopes,
    ]);

    // SUBMIT
    const onSubmit = useCallback((
        values,
        formikUtils,
    ) => {
        ({ setSubmitting } = formikUtils);
        includeStamp(values);
        dispatch(userUpsertAction(values));
    }, [
        dispatch,
    ]);

    return (
        <div>
            {/* SELECT USER */}
            <Formik
                initialValues={{ userId: currentRecord._id || '' }}
            >
                {({ values }) => (
                    <div className="card mt-3">
                        <div className="card-body">
                            <h5 className="card-title">User Details</h5>
                            <div className="form-row">
                                <div className="form-group col">
                                    <label>User Name</label>
                                    <UserDropDown
                                        value={values.userId}
                                        name="userId"
                                        onChange={(userId) => {
                                            // fetch User data
                                            dispatch(userEditAction({
                                                _id: userId,
                                            }));

                                            // fetch User data with auto populate
                                            dispatch(userSearchAction({
                                                where: {
                                                    _id: userId,
                                                },
                                            }));
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Formik>

            {/* ADD PERMISSIONS */}
            {currentRecord._id ? (
                <Formik
                    onSubmit={onSubmit}
                    enableReinitialize
                    initialValues={currentRecord}
                >
                    {(formikProps) => (
                        <Render
                            scopeTree={scopeTree}
                            {...formikProps}
                        />
                    )}
                </Formik>
            ) : null}
        </div>
    );
};

export default UserPermissions;
